import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import {
  Avatar,
  Button,
  ListItemAvatar,
  DialogTitle,
  Dialog,
  ListItem,
  ListItemButton,
  ListItemText,
  Card,
  Box,
  Tabs,
  Tab,
  DialogContent,
  DialogActions,
} from "@mui/material";
import PropTypes from "prop-types";
import { blue } from "@mui/material/colors";
import { AddBoxSharp, LocalHospital, Person } from "@mui/icons-material";
import React, { useContext, useEffect, useState } from "react";
import a11yProps from "../../helpers/ay-props";
import FormDialog from "../../helpers/FormDialog";
import moment from "moment-business-days";
import PageLoading from "../../helpers/PageLoading";
import { getError, getFileMime } from "../../store/helpers/common_functions";
import { IoIosDocument } from "react-icons/io";
import OpenDocument from "../../helpers/openDocument";
import TabPanel from "../../helpers/TabPanel";
import DatatableComponent from "../../helpers/DatatableComponent";
import { useHistory } from "react-router";
import SocketContext from "helpers/SocketContext";
import StatusLayout from "components/Status";

function SimpleDialog(props) {
  const { onClose, selectedValue, open, items } = props;

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleListItemClick = (value) => {
    onClose(value);
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>Request Category</DialogTitle>
      <DialogContent>
        <div className={"flex flex-wrap"}>
          {items.map((item) => (
            <div className={"w-full lg:w-6/12 xl:w-6/12 px-4"}>
              <ListItem disableGutters>
                <ListItemButton
                  onClick={() => handleListItemClick(item)}
                  key={item}
                >
                  <ListItemAvatar>
                    <Avatar sx={{ bgcolor: blue[100], color: blue[600] }}>
                      <LocalHospital />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={item.name} />
                </ListItemButton>
              </ListItem>
            </div>
          ))}
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(null)}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
}

SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
};

function Permission({ FetchDetails, GetAllResources, SetSelectedMenu }) {
  const [open, setOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState();
  const [info, setInfo] = React.useState();
  const [taken, setTaken] = React.useState(0);
  const [categories, setCategories] = useState([]);
  const [lineManagers, setLineManagers] = useState([]);
  const [tabValue, setTabValue] = React.useState(0);
  const [formOpen, setFormOpen] = React.useState(false);
  const [value, setValue] = React.useState({});
  const [fileView, setFileView] = useState(null);
  const [list, setList] = useState([]);
  const [count, setCount] = useState(0);
  const [year, setYear] = useState();
  const socket = useContext(SocketContext);
  const history = useHistory();
  const className = `'border px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150`;

  const calculateLeaveDays = (startDate, endDate, startTime, endTime) => {
    if (!startDate || !endDate) return null;
    const start = moment(startDate);
    const end = moment(endDate);
    if (start.format('YYYY-MM-DD') === end.format('YYYY-MM-DD')) {
      if (startTime && endTime) {
        const startDT = moment(`${start.format('YYYY-MM-DD')} ${startTime}`);
        const endDT = moment(`${end.format('YYYY-MM-DD')} ${endTime}`);
        const hrs = endDT.diff(startDT, 'hours', true);
        return Math.round(hrs * 100) / 100;
      }
      return 1;
    }
    return end.businessDiff(start);
  };

  let leaveDays = selectedValue?.leaveDays;

  if (selectedValue?.type === "annual") {
    // leaveDays = (info?.request?.remainingDays + info?.request?.carryoverDays) - info?.request?.leaveDays;
    leaveDays = info?.request?.remainingDays;
  }

  if (selectedValue?.isAnnual === true && selectedValue?.type !== "annual") {
    leaveDays =
      selectedValue?.leaveDays - info?.leaves[`${selectedValue?.name}`];
  }

  const getLineManagers = async () => {
    setLoading(true);
    setError(null);
    const resp = await FetchDetails(`/api/role/my-line-managers/`);
    setLoading(false);
    if (resp.status) {
      const listItem = resp?.data?.data;
      const managersList = [];
      for (const item of listItem) {
        const resourceList = item?.lineManager?.Resources;
        for (const resource of resourceList) {
          managersList.push(resource);
        }
      }
      setLineManagers(
        managersList?.map((v) => ({
          label: v?.acting
            ? `${v?.actor?.names} (acting on behalf of ${v?.names}) `
            : v.names,
          value: v?.acting ?? v.id,
        }))
      );
    } else {
      setError(getError(resp));
    }
    return resp;
  };
  useEffect(() => {
    getLineManagers().then();
  }, []);

  useEffect(() => {
    SetSelectedMenu({
      menu: "permission",
      title: "My Leave",
    });
    setYear(moment().format("YYYY"));
  }, []);

  const defaultFields = [
    {
      name: "startDate",
      type: "date",
      value: value["startDate"],
      weekendDisabled: true,
      label: "Start Date",
      disabled: leaveDays === 0 ? true : false,
      required: true,
      setValue: (val) => setValue0("startDate", val),
    },
    {
      name: "categoryId",
      type: "date",
      value: selectedValue?.id,
      label: "Category",
      hidden: true,
    },
    {
      name: "endDate",
      type: "date",
      label: "Return Date",
      weekendDisabled: true,
      value:
        leaveDays && value["startDate"]
          ? selectedValue?.type === "maternity"
            ? moment(value["startDate"]).add(90, "days").format("YYYY-MM-DD")
            : leaveDays && selectedValue?.type === "annual"
            ? value["endDate"]
            : selectedValue?.isAnnual === true
            ? value["endDate"]
            : moment(value["startDate"])
                .businessAdd(leaveDays, "days")
                .format("YYYY-MM-DD")
          : value["endDate"],
      maxDate:
        leaveDays && value["startDate"]
          ? selectedValue?.type === "maternity"
            ? moment(value["startDate"]).add(90, "days")
            : moment(value["startDate"]).businessAdd(leaveDays, "days")
          : null,
      minDate: value["startDate"]
        ? moment(value["startDate"])
        : null,
      required: leaveDays && value["startDate"] ? false : true,
      disabled:
        selectedValue?.isAnnual === false && !leaveDays
          ? false
          : leaveDays && value["startDate"] && selectedValue?.type === "annual"
          ? false
          : selectedValue?.isAnnual === true && leaveDays > 0
          ? false
          : true,
      setValue: (val) => {
        setValue0("endDate", val);
      },
    },
    {
      name: "startTime",
      type: "time",
      label: "Start Time (for same-day requests)",
      value: value["startTime"],
      required: false,
      hidden:
        !value["startDate"] ||
        !value["endDate"] ||
        moment(value["startDate"]).format("YYYY-MM-DD") !==
          moment(value["endDate"]).format("YYYY-MM-DD"),
      setValue: (val) => setValue0("startTime", val),
    },
    {
      name: "endTime",
      type: "time",
      label: "End Time (for same-day requests)",
      value: value["endTime"],
      required: false,
      hidden:
        !value["startDate"] ||
        !value["endDate"] ||
        moment(value["startDate"]).format("YYYY-MM-DD") !==
          moment(value["endDate"]).format("YYYY-MM-DD"),
      setValue: (val) => setValue0("endTime", val),
      validate: (time) => {
        if (value["startTime"] && time) {
          const startDT = moment(
            `${moment(value["startDate"]).format("YYYY-MM-DD")} ${value["startTime"]}`
          );
          const endDT = moment(
            `${moment(value["endDate"]).format("YYYY-MM-DD")} ${time}`
          );
          if (endDT.isSameOrBefore(startDT)) {
            return "End time must be after start time.";
          }
        }
        return true;
      },
    },
    {
      name: "leaveDays",
      type: "number",
      label: "Requested Days/Hours",
      disabled: true,
      required: false,
      value:
        value["startDate"] && value["endDate"]
          ? calculateLeaveDays(
              value["startDate"],
              value["endDate"],
              value["startTime"],
              value["endTime"]
            )
          : leaveDays &&
            selectedValue?.type !== "annual" &&
            selectedValue?.isAnnual !== true
          ? leaveDays
          : null,
    },
    {
      name: "maxDays",
      type: "number",
      label: "Max Leave Days",
      disabled: true,
      hidden: !selectedValue?.leaveDays,
      value: leaveDays,
    },
    {
      name: "supportDocument",
      type: "file-drag",
      label: "Support Document",
      value: value["supportDocument"],
      required: false,
      setValue: (val) => setValue0("supportDocument", val),
    },
  ];

  const extraFields = [
    {
      name: "location",
      type: "text",
      label: "Location",
      value: value["location"],
      required: false,
      setValue: (val) => setValue0("location", val),
    },
    {
      name: "lineManager",
      type: "select",
      label: "Line Manager",
      value: value["lineManager"],
      values: lineManagers,
      required: true,
      setValue: (val) => setValue0("lineManager", val),
    },

    {
      name: "description",
      type: "textarea",
      label: "Description",
      value: value["description"],
      required: false,
      setValue: (val) => setValue0("description", val),
    },
  ];

  const studyFields = [
    {
      name: "country",
      type: "text",
      label: "Country Name",
      value: value["country"],
      required: false,
      setValue: (val) => setValue0("country", val),
    },
    {
      name: "schoolName",
      type: "text",
      label: "School Name",
      value: value["schoolName"],
      required: true,
      setValue: (val) => setValue0("schoolName", val),
    },
    {
      name: "educationLevel",
      type: "text",
      label: "Education Level",
      value: value["educationLevel"],
      required: true,
      setValue: (val) => setValue0("educationLevel", val),
    },
    {
      name: "course",
      type: "text",
      label: "Course to be Attended",
      value: value["course"],
      required: true,
      setValue: (val) => setValue0("course", val),
    },
  ];
  const sickFields = [
    {
      name: "country",
      type: "text",
      label: "Country Name",
      value: value["country"],
      required: false,
      setValue: (val) => setValue0("country", val),
    },
    // {
    //     name:"illnessType",
    //     type:"text",
    //     label:"Type of Illness",
    //     value: value['illnessType'],
    //     required: true,
    //     setValue: (val) => setValue0('illnessType', val),
    // },
    {
      name: "hospitalName",
      type: "text",
      label: "Hospital Name",
      value: value["hospitalName"],
      required: true,
      setValue: (val) => setValue0("hospitalName", val),
    },
  ];

  const columns = [
    {
      name: "category.name",
      data: "category.name",
      label: "Category",
      options: {
        // filter:false
      },
    },
    {
      name: "leaveDays",
      data: "leaveDays",
      label: "Days Taken",
      options: {
        customBodyRenderLite: (dataIndex, rowIndex) => {
          const row = list[rowIndex];
          return (
            row.LeaveDetails?.reduce(
              (total, item) => total + (item.numberOfDays ?? 0),
              0
            ) ?? 0
          ); // Sum up numberOfDays from LeaveDetails
        },
      },
    },
    {
      name: "remainingDays",
      data: "remainingDays",
      label: "Days Remaining",
      options: {
        customBodyRenderLite: (dataIndex, rowIndex) => {
          const row = list[rowIndex];
          if (row.category.type === "annual") {
            const availableDays =
              row.category.leaveDays + (row.carryoverDays ?? 0); // Total leave days
            const daysTaken = row.leaveDays ?? 0; // Days already taken
            return availableDays - daysTaken; // Calculate remaining days
          }
          return row.remainingDays;
        },
      },
    },
    {
      name: "startDate",
      data: "startDate",
      label: "Start Date",
      options: {
        customBodyRenderLite: (dataIndex, rowIndex) =>
          list[rowIndex]?.category?.type === "annual" ? (
            <div>
              {list[rowIndex].annualStarts?.split(",")?.map((v) => (
                <div style={{ minWidth: "100px" }}>
                  {moment(v).format("YYYY-MMM-DD")}
                </div>
              ))}
            </div>
          ) : (
            moment(list[rowIndex]?.startDate).format("YYYY-MMM-DD")
          ),
      },
    },
    {
      name: "endDate",
      data: "endDate",
      label: "Return Date",
      options: {
        customBodyRenderLite: (dataIndex, rowIndex) =>
          list[rowIndex]?.category?.type === "annual" ? (
            <div>
              {list[rowIndex].annualEnds?.split(",")?.map((v) => (
                <div className={"flex"} style={{ minWidth: "100px" }}>
                  <div className={"grow"}>
                    {moment(v).format("YYYY-MMM-DD")}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            moment(list[rowIndex]?.endDate).format("YYYY-MMM-DD")
          ),
      },
    },
    {
      name: "id",
      data: "id",
      label: "Support Document",
      options: {
        customBodyRender: (v) => {
          const obj = list.find((vx) => vx.id === v);

          return obj?.supportDocument ? (
            <Button
              onClick={(e) => {
                e.stopPropagation();
                setFileView(obj);
              }}
              size={"small"}
              variant={"outlined"}
              startIcon={<IoIosDocument />}
            >
              View
            </Button>
          ) : null;
        },
      },
    },
    {
      name: "updatedAt",
      data: "updatedAt",
      label: "Submitted At",
      options: {
        customBodyRender: (v) => moment(v).format("YYYY-MMM-DD"),
      },
    },
    {
      name: "status",
      data: "status",
      label: "Status",
      options: {
        customBodyRender: (v) => (
          <StatusLayout status={v === "done" ? "Completed" : v} />
        ),
      },
    },
  ];

  const annualColumns = [
    {
      name: "name",
      data: "name",
      label: "Category",
      options: {
        // filter:false
      },
    },
    {
      name: "days",
      data: "days",
      label: "Days Taken",
      // options: {
      //     // customBodyRender: (v) => v
      //     customBodyRenderLite: (dataIndex, rowIndex) => list[rowIndex]?.category?.type === "annual" ? list[rowIndex]?.Resource?.leaveDays : list[rowIndex]?.leaveDays
      // }
    },
    {
      name: "leaveDays",
      data: "leaveDays",
      label: "Leave Days",
      options: {
        // customBodyRender: (v) => (30 - v)
        // customBodyRenderLite: (dataIndex, rowIndex) => list[rowIndex]?.category?.type === "annual" ? list[rowIndex]?.Resource?.remainingDays : null
      },
    },
  ];

  const [fields, setFields] = React.useState([
    ...defaultFields,
    ...extraFields,
  ]);
  const loadData = async () => {
    setLoading(true);
    setError(null);
    const resp = await FetchDetails(`/api/request/requests/info`);
    setLoading(false);
    if (resp.status) {
      setInfo(resp.data);
      setTaken(resp.data?.request?.leaveDays);
    } else {
      setError(getError(resp));
    }
    return resp;
  };

  useEffect(() => {
    loadData().then();
  }, []);
  const loadCategories = async () => {
    const resp = await FetchDetails(`/api/request/categories/`);
    if (resp.status) {
      setCategories(resp.data.categories);
    }
  };

  useEffect(() => {
    loadCategories().then();
    GetAllResources();
  }, [FetchDetails, GetAllResources]);

  const buildFields = () => {
    if (selectedValue) {
      let allFields = defaultFields;
      if (selectedValue.type === "study") {
        allFields = [...allFields, ...studyFields, ...extraFields];
      } else if (selectedValue.type === "sick") {
        allFields = [...allFields, ...sickFields, ...extraFields];
      } else {
        allFields = [...allFields, ...extraFields];
      }

      setFields(allFields);
    } else {
      setFields([]);
    }
  };

  useEffect(buildFields, [selectedValue, value]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
    if (value) {
      setFormOpen(true);
    }
    setSelectedValue(value);
  };

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue((v) => {
      v[name] = val;
      return { ...v };
    });
  };

  const button = (
    <Button
      variant="outlined"
      startIcon={<AddBoxSharp />}
      onClick={handleClickOpen}
    >
      Request Leave
    </Button>
  );

  const onRowClick = (data, { rowIndex }) => {
    history.push(`/admin/permission/details/${list[rowIndex].id}`);
  };

  const onSuccess = () => {
    setCount((v) => v + 1);
    loadData().then();
  };

  return (loading && !info) || error || !info ? (
    <PageLoading error={loading ? null : error} onRefresh={loadData} />
  ) : (
    <div>
      <SimpleDialog
        selectedValue={selectedValue}
        open={open}
        items={categories}
        onClose={handleClose}
      />
      <Dialog
        maxWidth={"md"}
        fullWidth={true}
        open={fileView !== null}
        onClose={() => setFileView(null)}
      >
        <DialogContent>
          {fileView !== null && (
            <OpenDocument
              downloadable={true}
              document={fileView?.supportDocument}
              name={"supportDocument"}
              specialName={fileView?.supportDocument}
              type={"permission-doc"}
              mimeType={getFileMime(fileView?.supportDocument)}
            />
          )}
        </DialogContent>
      </Dialog>
      {formOpen && (
        <FormDialog
          onSuccess={() => {
            onSuccess();
            socket.emit("sendNotification", {
              message: `You have a new permission request from ${info.resource.names}`,
              resourceId: info.resource.id,
              receiverId: value?.lineManager,
              type: "permission_request",
              projectId: info.resource.id,
            });
          }}
          url={"/api/request/create"}
          formAlert={
            <div dangerouslySetInnerHTML={{ __html: selectedValue?.message }} />
          }
          maxWidth={"md"}
          col={6}
          title={"Submit New Permission Request"}
          open={formOpen}
          setOpen={() => {
            setSelectedValue(null);
            setFormOpen(false);
          }}
          fields={fields}
        />
      )}
      <Card>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={tabValue}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="Pending Leave" {...a11yProps(0)} />
            <Tab label="Approved" {...a11yProps(1)} />
            <Tab label="Denied" {...a11yProps(2)} />
            <Tab label="Shared" {...a11yProps(3)} />
            <Tab label="My Annual Leaves" {...a11yProps(4)} />
          </Tabs>
        </Box>
        <div>
          <TabPanel index={0} value={tabValue} p={0}>
            {info.pending > 0 ? (
              <div>
                <DatatableComponent
                  onRowClick={onRowClick}
                  processData={(data) => {

                    const filteredList = data.data.filter((item) => {
                      // Allow non-annual leave requests
                      if (!item.category || item.category.type !== "annual") {
                        return true;
                      }

                      // For annual leaves, perform strict validation
                      const hasValidDates =
                        item.annualStarts &&
                        item.annualEnds &&
                        item.annualStarts !== "NULL" &&
                        item.annualEnds !== "NULL" &&
                        item.annualStarts
                          .split(",")
                          .every((date) => date && date.trim() !== "") &&
                        item.annualEnds
                          .split(",")
                          .every((date) => date && date.trim() !== "");


                      return hasValidDates;
                    });

                    setList(filteredList);
                    return { ...data, data: filteredList };
                  }}
                  url={`/api/request/datatable?status=pending-review&count=${count}&year=${year}`}
                  columns={columns}
                  title={
                    <input
                      className={className}
                      value={year}
                      onChange={(e) => setYear(e.target.value)}
                    />
                  }
                />
              </div>
            ) : (
              <div
                style={{ height: "70vh" }}
                className={"flex items-center justify-center"}
              >
                {button}
              </div>
            )}
          </TabPanel>
          <TabPanel index={1} value={tabValue} className={""} p={0}>
            <DatatableComponent
              onRowClick={onRowClick}
              processData={(data) => {
                setList(data.data);
                return data;
              }}
              url={`/api/request/datatable?status=approved&count=${count}&year=${year}`}
              columns={columns}
              title={
                <input
                  className={className}
                  value={year}
                  onChange={(e) => setYear(e.target.value)}
                />
              }
            />
          </TabPanel>
          <TabPanel index={2} value={tabValue} className={""} p={0}>
            <DatatableComponent
              onRowClick={onRowClick}
              processData={(data) => {
                setList(data.data);
                return data;
              }}
              url={`/api/request/datatable?status=denied&count=${count}&year=${year}`}
              columns={columns}
              title={
                <input
                  className={className}
                  value={year}
                  onChange={(e) => setYear(e.target.value)}
                />
              }
            />
          </TabPanel>
          <TabPanel index={3} value={tabValue} className={""} p={0}>
            <DatatableComponent
              onRowClick={onRowClick}
              processData={(data) => {
                setList(data.data);
                return data;
              }}
              url={`/api/request/datatable?status=shared&count=${count}&year=${year}`}
              columns={columns}
              title={
                <input
                  className={className}
                  value={year}
                  onChange={(e) => setYear(e.target.value)}
                />
              }
            />
          </TabPanel>
          <TabPanel index={4} value={tabValue} className={""} p={0}>
            <DatatableComponent
              onRowClick={onRowClick}
              processData={(data) => {
                setList(data.data);
                return data;
              }}
              url={`/api/request/request-permissions?status=shared&count=${count}&year=${year}`}
              columns={annualColumns}
              title={
                <input
                  className={className}
                  value={year}
                  onChange={(e) => setYear(e.target.value)}
                />
              }
            />
          </TabPanel>
        </div>
      </Card>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Permission);
